export function rem2px(value: string, size = 16) {
  if (/([0-9]+)\.?([0-9]*)\s*rem/.test(value)) {
    return parseFloat(value.replace(/D/g, '')) * size + 'px';
  }
  return value;
}
